export default function polyfillToggleAttribute() {
    if (!Element.prototype.toggleAttribute) {
        Element.prototype.toggleAttribute = function toggleAttributePolyfill(name, force) {
            const hasAttribute = this.hasAttribute(name);
            if (hasAttribute === force) {
                return force;
            }
            if (force !== false && !hasAttribute) {
                this.setAttribute(name, '');
                return true;
            }
            this.removeAttribute(name);
            return false;
        };
    }
}
polyfillToggleAttribute();
